import { FivetranServiceEnum, tripleWhaleSchema } from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

/** Setup form for the Triple Whale Fivetran connector (API-key authentication). */
export const TripleWhaleFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.triple_whale,
    schema: tripleWhaleSchema,
    defaultConfig: {
      schema: FivetranServiceEnum.enum.triple_whale,
      api_key: "",
      shop_domain: "",
    },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="triple-whale"
      submitLabel="Create"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />

      <form.AppField name="config.shop_domain">
        {(field) => (
          <field.TextField
            label="Shop domain"
            placeholder="mystore.myshopify.com"
          />
        )}
      </form.AppField>

      <form.AppField name="config.api_key">
        {(field) => (
          <field.PasswordField
            label="API Key"
            placeholder="XXXXXXXXXXXXXXXXXXXXXXXX"
          />
        )}
      </form.AppField>
    </ConnectionFormShell>
  );
};
